import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Beheer (ingelogd)
export const fetchShareLinks = async (lessonId) => (
  await axios.get(`${API}/connectlessen-share`, { params: { lesson_id: lessonId } })
).data;

export const fetchSharePreview = async (lessonId) => (
  await axios.get(`${API}/connectlessen-share/preview`, { params: { lesson_id: lessonId } })
).data;

export const createShareLink = async (payload) => (await axios.post(`${API}/connectlessen-share`, payload)).data;

export const revokeShareLink = async (linkId) => (await axios.post(`${API}/connectlessen-share/${linkId}/revoke`)).data;

// Publiek (bezoeker). Bewust `fetch` zonder cookies/Authorization: de globale axios-interceptors van de
// ingelogde app mogen een publieke 401 (toegangscode nodig) nooit als verlopen sessie behandelen, en
// de toegangscode gaat in een header zodat hij niet in URL's of logs terechtkomt.
export const fetchSharedLesson = async (token, accessCode) => {
  const response = await fetch(`${API}/public/connectlessen/${encodeURIComponent(token)}`, {
    method: 'GET',
    credentials: 'omit',
    referrerPolicy: 'no-referrer',
    cache: 'no-store',
    headers: accessCode ? { 'X-Share-Code': accessCode } : {},
  });
  let body = null;
  try { body = await response.json(); } catch (error) { body = null; }
  if (response.ok) return { status: 'ready', ...body };
  const detail = body?.detail;
  if ((response.status === 401 || response.status === 403) && detail?.code_required) {
    return { status: 'code', wrongCode: response.status === 403, message: detail.message };
  }
  if (response.status === 429) return { status: 'limited', message: typeof detail === 'string' ? detail : null };
  if (response.status === 404) return { status: 'invalid' };
  return { status: 'error' };
};
